import Proxy from './Proxy';

class PatientProxy extends Proxy {
  /**
   * The constructor for the CareplanProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/Patients', parameters);
  }


  /**
   * Method used to create patient details.
   *
   * @param {Object} data data to create patient
   *
   * @returns {Promise} The result in a promise.
   */
  create(data) {
    return this.submit('post', `/Users/patient/createByResponder`, data);
  }
  /**
   * Method used to view health record using patient id.
   *
   * @param {id} id.
   *
   * @returns {Promise} The result in a promise.
   */
  view(id) {
    return this.submit('get', `${this.endpoint}/${id}/record`);
  }

  /**
   * Method used to fetch patient details.
   *
   * @param {Object} data data to fetch patient details
   *
   * @returns {Promise} The result in a promise.
   */
  fetchPatients(data) {
    return this.submit('post', `${this.endpoint}/all`, data);
  }


  /**
   * Method used to update patient details.
   *
   * @param {Object} data data to update patient
   *
   * @returns {Promise} The result in a promise.
   */
  update({ data, id }) {
    return this.submit('patch', `${this.endpoint}/${id}`, data);
  }

  /**
   * Method used to fetch patient details.
   *
   * @param {Object} data data to fetch patient details
   *
   * @returns {Promise} The result in a promise.
   */
  fetchPatientProgresses(data) {
    return this.submit('post', `${this.endpoint}/patientsProgress`, data);
  }

  /**
   * Used to assign careplan details.
   * @param {*} data - careplan data
   */
  assignCareplan(formData) {
    if (formData.isEnrollmentCareplan) {
      return this.submit('post', `${this.endpoint}/assignPendingCarePlan`, formData.data);
    } else {
      return this.submit('post', `${this.endpoint}/assignCarePlan`, formData.data);
    }
  }


  /**
   * Used to assign careplan details.
   * @param {*} data - careplan data
   */
  unAssignCareplan(data) {
    return this.submit('post', `${this.endpoint}/unAssignCarePlan`, data);
  }

  /**
   * Patient Progress Details
   * @param {*} id - id of the patient
   */
  fetchProgressDetails(id) {
    return this.submit('get', `${this.endpoint}/${id}/progressDetails`);
  }


  /**
   * Patient Progress Details by cycle no
   * @param {*} data - data with id and cycle no
   */
  fetchProgressDetailsByCycle({ id, cycleNo }) {
    return this.submit('get', `${this.endpoint}/interventionProgressByCycle/${id}/${cycleNo}`);
  }

  /**
   * Method used to update patient email and mobile number details.
   *
   * @param {Object} data data to update patient
   *
   * @returns {Promise} The result in a promise.
   */
  updatePatientData(data) {
    return this.submit('post', `${this.endpoint}/updatePatientData`, data)
  }
}

export default PatientProxy;
